import { useState } from "react";
import ContactModal from "./ContactModal";
import "./Hero.css";

export default function Hero() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="hero">
        <div className="overlay">
          <p>Zuverlässig. Professionell. Vielseitig.</p>
          <button className="cta" onClick={() => setOpen(true)}>
            Jetzt Kontakt aufnehmen
          </button>
        </div>
      </header>

      {open && <ContactModal onClose={() => setOpen(false)} />}
    </>
  );
}